var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.publicToken !== null && _vm.getContactForm === true
    ? _c(
        "button",
        {
          staticClass: "rp-buy-button rp-button",
          class: { "is-loading": _vm.isClick },
          style: {
            backgroundColor: _vm.color.secondaryMain,
            color: _vm.color.secondarySub,
            borderColor: _vm.color.secondaryMain,
            fontFamily: _vm.globalFont
          },
          on: { click: _vm.submitContactForm }
        },
        [
          _vm.contactForm.form.contact_button_icon !== "" &&
          _vm.contactForm.form.contact_button_icon !== null &&
          _vm.rpLink !== ""
            ? [
                _c("span", { staticClass: "rp-icon" }, [
                  _c("i", {
                    class: "fa " + _vm.contactForm.form.contact_button_icon
                  })
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.contactForm.form.contact_button_id === "-1"
            ? _c("span", { staticClass: "custom-text-overflow" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.contactForm.form.contact_button_custom_text) +
                    "\n    "
                )
              ])
            : _c("span", [
                _vm.locale == "en"
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.contactForm.form.contact_button_text_en) +
                          "\n      "
                      )
                    ])
                  : _vm.locale == "vi"
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.contactForm.form.contact_button_text_vi) +
                          "\n      "
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.contactForm.form.contact_button_text_th) +
                          "\n      "
                      )
                    ])
              ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ef3e781", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef3e781","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cartForm/CartFormButton.vue
// module id = null
// module chunks = 